import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Semesters from "./Views/Semesters";
import AllCourses from "./Views/AllCourses";
import CourseDetails from "./Views/CourseDetails";
import useFetch from "./Components/utils/useFetch";
import Breadcrumbs from "./Components/BreadCrumbs";
export const TermsContext = React.createContext();

function App() {
  const [terms, setTerms] = useState([]);
  const [error, setError] = useState([]);
  const { get, isLoading } = useFetch();

  useEffect(() => {
    get("/activesemesters")
      .then((data) => {
        setTerms(data);
      })
      .catch((error) => {
        setError(error);
      });
  }, []);


  return (
    <BrowserRouter>
      <Breadcrumbs />
      <TermsContext.Provider value={{ terms, isLoading }}>
        <Routes>
          <Route path={process.env.PUBLIC_URL} element={<Semesters />} />
          <Route
            path={process.env.PUBLIC_URL + "/:id"}
            element={<AllCourses 
            />}
          />
          <Route
            path={process.env.PUBLIC_URL + "/:id/:id"}
            element={<CourseDetails
    
            />
          }
          />
        </Routes>
      </TermsContext.Provider>
    </BrowserRouter>
  );
}

export default App;
